import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-card",
  "use": "icon-card-usage",
  "viewBox": "0 0 38 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 30\" id=\"icon-card\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h38v30H0z\" /><path fill=\"currentColor\" d=\"M35 12v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V12h32zm-15 9H6v3h14v-3zm5 0h-3v3h3v-3zm8-18a2 2 0 0 1 2 2v4H3V5a2 2 0 0 1 2-2h28z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol